import { Link } from "react-router-dom";
import { useData } from "data/data-provider";
import moment from "moment";

const Logo = () => {
  const { companyDetails, setSelectedWeeks, ourCompany } = useData();
  const time = moment();
  const timeInMilliseconds = time.valueOf();

  const companyLogo = companyDetails?.company_logo
    ? `${companyDetails?.company_logo}?date=${timeInMilliseconds}`
    : "";

  const companyId = ourCompany?.company?.id;
  const logoWidth = companyId === 1592 ? 200 : 120;
  const logoHeight = companyId === 1592 ? 150 : 60;

  const handleClick = () => {
    setSelectedWeeks([]);
  };

  return (
    <Link
      to="/"
      onClick={handleClick}
      className={`ttnc-logo inline-block text-text-color focus:outline-none focus:ring-0`}
    >
      {companyLogo && (
        <img
          width={logoWidth}
          height={logoHeight}
          src={companyLogo}
          alt={companyLogo ? "Company Logo" : "Logo"}
        />
      )}
    </Link>
  );
};

export default Logo;
